module.exports = __webpack_public_path__ + "static/media/epson.ade1aa46.png";